import { useState } from 'react'

import bundledFallback from '../assets/companylogo.svg'

const brandingLogoUrl = '/auth/branding/logo'

export function BrandingLogo({ alt, className }: { alt: string; className?: string }) {
  const [src, setSrc] = useState(brandingLogoUrl)

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      decoding="async"
      onError={() => {
        if (src !== bundledFallback) {
          setSrc(bundledFallback)
        }
      }}
    />
  )
}
